import { createContext } from "react";
import { Accessible, Feature, Settings, Stats, Update, Sso, Identity, Role } from "../../../types"

export type AppReducerState = {
  stats: Stats
  version: string
  buildVersion: string
  update: Update,
  settings: Settings
  userData?: Accessible
  sso: Sso,
  licensedFeatures?: Feature[],
  licensed?: (feature: Feature) => boolean,
  isUserDataLoading: boolean,
  isSsoDataLoading: boolean,
  isEditing: boolean,
  identity: Identity,
  developerLicense: boolean,
  roles: Role[]
};

export type ContextTypeProps = AppReducerState

export const initState = {
  stats: {} as Stats,
  version: '',
  buildVersion: '',
  update: {} as Update,
  userData: {} as Accessible,
  settings: {} as Settings,
  sso: {} as Sso,
  licensedFeatures: [Feature.Api, Feature.Automation, Feature.Dashboard],
  licensed: () => false,
  isUserDataLoading: true,
  isSsoDataLoading: true,
  isEditing: false,
  identity: null,
  developerLicense: false,
  roles: []
};

export const AppContext = createContext<AppReducerState>({
  ...initState
});
